{
  "languages": {
    "es": "Español",
    "cat": "Català"
  },
  "short_languages": {
    "es": "ES",
    "cat": "CAT"
  },
  "header": {
    "mallorca": "Mallorca",
    "mallorca_edition": "23.07 - 31.07 / Mallorca",
    "online_edition": "24.07 - 24.08 / filmin.es",
    "editions": "Edicions",
    "history": "Història",
    "online": "Online",
    "international": "Internacional",
    "start": "Inici",
    "program": "Programa",
    "program_complete": "Programa complet",
    "movies": "Pel·lícules",
    "music": "Música",
    "talks": "Talks",
    "parrilla": "Graella",
    "professionals": "Professionals",
    "mallorca_talents_lab": "Mallorca Talents Lab",
    "talents_lab": "Talents lab",
    "partakers": "Convidats",
    "eurovod": "Eurovod",
    "screen_stars": "Screen Starts",
    "news": "Notícies",
    "press": "Premsa",
    "mallorca_an_island_of_movie": "Mallorca, Una illa de Pel·lícula",
    "encuentro_comica": "Trobada COMICA",
    "emerging_workshop": "Taller Emergents"
  },
  "footer": {
    "press_kit": "Kit de premsa",
    "contact": "Contacte",
    "sponsors": "Sponsors",
    "proyect_of": "Atlàntida Mallorca Film Fest és un projecte de"
  },
  "actions": {
    "share": "Compartir",
    "copy": "Copiar",
    "copied": "Copiat",
    "close": "Tancar",
    "more_details": "Més info"
  },
  "home": {
    "header_description": "13a edició Atlàntida Mallorca Film Fest",
    "header_description2": "Una setmana a Mallorca. Un mes a Filmin",
    "header_description3": "Fins al 31 de Maig presenta el teu projecte i aconsegueix que FILMIN participi a la coproducció.",
    "discover_this_years_content": "Més de 80 esdeveniments exclusius",
    "follow_festival_at": "Segueix el festival amb",
    "see_the_full_program": "Veure el programa complet",
    "play_trailer": "Veure tràiler",
    "watch_aftermovie": "Veure resum",
    "overview_movies": "Les grans triomfadores dels Festivals de Berlín i Sundance s'estrenaran en exclusiva a l'Atlàntida Mallorca Film Fest.",
    "overview_music": "No et perdis els concerts dels millors artistes emergents del nostre país: Belén Aguilera, Alice Wonder, Natalia Lacunza i grans coneguts del festival com Júlia Colom i Putochinomaricón.",
    "overview_talks": "Com és habitual, una part de la programació vindrà acompanyada de xerrades prèvies amb autors de referència que introduiran les pel·lícules. Entre els convidats de les edicions anteriors hi ha Pablo Simón, El Barroquista o Judit Vega.",
    "featured_events": "Imprescindibles d'aquesta edició",
    "sign_up_title_1": "Secció oficial",
    "sign_up_subtitle_1": "Inscriu-te fins al 16 de Maig",
    "sign_up_title_2": "Atlàntida Mallorca Talents Lab - WIP",
    "sign_up_subtitle_2": "Inscriu-te fins L'1 de Juny",
    "overview_talents_lab": "Un any més convertint Mallorca en un punt de trobada per a professionals de la indústria.",
    "overview_bono": "Acosegueix el teu passaport AMFF-Filmin a Cines Rivoli.",
    "sign_up_talent": "INSCRIU-TE A TALENTS",
    "see_the_full_program_23": "Veure programació",
    "sign_up_film": "INSCRIU LA TEVA PEL·LÍCULA"
  },
  "post": {
    "share_this_with_your_comunity": "Comparteix això amb la teva comunitat social",
    "or_copy_link": "o copiar enllaç",
    "lastest_news": "Últimes notícies",
    "see_latest_news": "Veure totes les notícies",
    "all_news": "Totes les notícies"
  },
  "error": {
    "are_you_lost": "T'has perdut?",
    "calm_down_if_youre_lost": "Ens passa a tots, no et preocupis. Potser has escrit malament l'adreça, o l'enllaç que buscaves ja no existeix.",
    "take_me_home": "Anar al inici",
    "no_events_in_filter": "No hi ha cap esdeveniment que coincideixa amb els filtres seleccionats.",
    "try_selecting_a_different_filter": "Prova seleccionant un altre dia o un altre tipus d'esdeveniment."
  },
  "coming_soon": {
    "stay_tuned": "Programació completa 1 de Juliol",
    "come_back": "Mil gràcies per la paciència i l'interés."
  },
  "events": {
    "download_schedule": "Descarrega la parrilla",
    "event_types": {
      "all": "Tot",
      "movies": "Movies",
      "movie": "Pel·lícula",
      "music": "Música",
      "talks": "Talks",
      "talk": "Talk"
    },
    "go_to_next_day": "Anar al dia següent",
    "day": "Dia",
    "location": "Localització",
    "section": "Secció",
    "clear_all": "Treure filtres",
    "buy_tickets": "Comprar entrades",
    "book_tickets": "Reservar entrades",
    "about_movie": "Sobre la pel·lícula",
    "the_same_day": "El mateix día",
    "listen_in_spotify": "Escoltar en Spotify",
    "original_title": "Títol original",
    "tags": "Temes",
    "staff": "Repartiment",
    "others_projection": "Altres pel·lícules",
    "others_conference": "Altres conferències",
    "others_concert": "Altres concerts",
    "full_capacity": "Aforament complet",
    "see_movie": "Veure pel·lícula",
    "view_all_movies": "Veure totes les pel·lícules",
    "coming_soon": "Properament"
  },
  "talents": "<p>Atlàntida Mallorca Film Fest, en la seva dotzena edició, torna a apostar per els joves talents del cine. Amb la col·laboració de Media i Europa Creativa Catalunya, llançem la cinquena convocatòria del Mallorca Talents Lab (“Talents Lab” en endevant), un espai que et permetrà desenvolupar el teu projecte de llargmetratge sota la lupa dels millors experts del sector cinematogràfic.</p>  <p>El  Talents  Lab  té  com  objectiu estrènyer llaços  entre  joves  creadors  i  professionals  consolidats  que tutoritzaràn  i  assessoraran  en  el  desenvolupament  dels  projectes  participants,  preparant-los per accedir a convocatòries internacionals i al seu pas per festivales.</p> <p> Aquest any el Talents Lab va més enllà de la ficció per apropar-se també al documental i incorporar la posibilitat d’aconseguir el suport de Comunitat Filmin, S.L. ( “Filmin”), mitjançant el finançament anticipat de la futura obra audiovisual, comptant amb el suport i seguiment del seu equip editorial durant un any.</p>",
  "international": {
    "countries": "Portugal. Grècia. Sèrbia. Bulgària. Romania. Albània.",
    "title": "Edició Internacional",
    "content": "La IV Edició del Festival online internacional que s’efectuarà a Portugal Serbia, Grecia, Rumania i Albania es celebrarà de l’1 de desembre al 31 de desembre de 2022. La programació es farà pública al novembre.",
    "here": "aqui"
  },
  "online": {
    "title": "Online edition",
    "description": "La programació completa del festival online que se celebrarà a Filmin s'anunciarà el dia 8 de juliol a les 12h."
  }
}
